export interface Language {
    readonly name: string,
    readonly value: string
}

export const languageResource = [
    {
        name: 'Select Language', value: ''
    },
    {
        name: 'Deutsch', value: 'de'
    },
    {
        name: 'English', value: 'en'
    },
    {
        name: 'Spanish', value: 'es'
    },
    {
        name: 'French', value: 'fr'
    },
    {
        name: 'Italian', value: 'it'
    },
    {
        name: 'Polski', value: 'pl'
    },
    {
        name: 'Dutch', value: 'nl'
    },
    {
        name: 'Portuguese', value: 'pt'
    },
    {
        name: 'Hindi', value: 'hi'
    },
    {
        name: 'Chinese', value: 'zh'
    },
    {
        name: 'Japanese', value: 'ja'
    },
    {
        name: 'Korean', value: 'ko'
    }
];
